import { ClientBillingDetailModel, ClientBillingModel } from './client-billing.model';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { MasterDataService } from './../../services/master-data.service';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CommonMessageService } from 'src/app/services/common-message.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-client-billing',
  templateUrl: './client-billing.component.html',
  styleUrls: ['./client-billing.component.css'],
})
export class ClientBillingComponent implements OnInit {
  branchDataList;
  clientList;
  assignmentList;
  branch;
  client;
  assignment;
  diaryClientBillingList: ClientBillingDetailModel[];
  travelSheetClientBillingList: ClientBillingDetailModel[];
  groupClientBillingList;
  finalGroupByMonth = [];
  showDetailTable: Boolean = false;

  constructor(
    private masterDataService: MasterDataService,
    private humanResourceService: HumanResourceService,
    private commonMessageService: CommonMessageService
  ) { }

  ngOnInit(): void {
    this.branch = "";
    this.client = "";
    this.assignment = "";
    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchDataList = res;
    // });
    this.masterDataService.getBranch().subscribe((res) => {
      const userBranchId = Number(localStorage.getItem('branchId'));
      const branches = res as any[];

      if (userBranchId === 7) {
        this.branchDataList = branches.filter(b => [6, 7, 10].includes(b.id));
      } else {
        this.branchDataList = branches;
      }
    });
  }
  onSelectBranch() {
    this.showDetailTable = false;
    this.clientList = [];
    this.assignmentList = [];
    this.humanResourceService
      .getClientsByBranch(this.branch)
      .subscribe((res: any) => {
        console.log('response details', res);
        if (res.length > 0) {
          this.clientList = res;
        } else {
          this.commonMessageService.swalAlertWithoutIcon('', 'Client not present for this Branch');

        }
      });
  }
  onSelectClient() {
    this.showDetailTable = false;
    this.humanResourceService
      .getAssignmentByClient(this.client)
      .subscribe((res) => {
        this.assignmentList = res;
        if (this.assignmentList.length > 0) {
          this.assignmentList.splice(0, 0, {
            id: 0,
            isCheckListRequired: true,
            name: 'All Assignments',
          });
        } else {
          this.commonMessageService.swalAlertWithoutIcon('', 'Assignments not present for this Client');
        }
      });
  }
  onClickBranchByClient() {
    this.finalGroupByMonth = [];
    if (this.client > 0 && this.branch > 0 && this.assignment >= 0) {
      this.showDetailTable = true;
      this.humanResourceService
        .getClientBillingReport(this.client, this.assignment)
        .subscribe((res: any) => {
          console.log('Billing response', res);
          this.diaryClientBillingList = res.diaryDetailsDeatilsRest;
          this.travelSheetClientBillingList = res.tsheetDetailsDeatilsRest;
          this.getTotalByMonthYear();
        });
    } else {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please Select Branch,Client & Assignment');
    }
  }

  getMonthFormat(getMonth) {
    return moment(getMonth, 'MM').format('MMMM');
  }

  getTotalByMonthYear() {
    var helper = {};
    var result = this.diaryClientBillingList.reduce(function (r, o) {
      var key = o.month + '-' + o.year + '-' + o.mode;

      if (!helper[key]) {
        helper[key] = Object.assign({}, o);
        r.push(helper[key]);
      } else {
        helper[key].amount += o.amount;
      }
      return r;
    }, []);
    this.groupClientBillingList = result;

    for (let i = 0; i < this.groupClientBillingList.length; i++) {
      if (this.finalGroupByMonth.length > 0) {
        var flag = false;
        for (let j = 0; j < this.finalGroupByMonth.length; j++) {
          if (
            this.groupClientBillingList[i].month ==
            this.finalGroupByMonth[j].month &&
            this.groupClientBillingList[i].year ==
            this.finalGroupByMonth[j].year
          ) {
            if (this.groupClientBillingList[i].mode == 'Four Wheeler') {
              this.finalGroupByMonth[
                j
              ].amount.fourWheeler = this.groupClientBillingList[i].amount;
            } else if (this.groupClientBillingList[i].mode == 'Two Wheeler') {
              this.finalGroupByMonth[
                j
              ].amount.twoWheeler = this.groupClientBillingList[i].amount;
            } else if (
              this.groupClientBillingList[i].mode == 'Bus/Auto/Other'
            ) {
              this.finalGroupByMonth[
                j
              ].amount.busAuto = this.groupClientBillingList[i].amount;
            }
            flag = true;
          }
        }
        if (!flag) {
          var amount = {
            twoWheeler: 0,
            fourWheeler: 0,
            busAuto: 0,
          };
          if (this.groupClientBillingList[i].mode == 'Four Wheeler') {
            amount.fourWheeler = this.groupClientBillingList[i].amount;
          } else if (this.groupClientBillingList[i].mode == 'Two Wheeler') {
            amount.twoWheeler = this.groupClientBillingList[i].amount;
          } else if (this.groupClientBillingList[i].mode == 'Bus/Auto/Other') {
            amount.busAuto = this.groupClientBillingList[i].amount;
          }
          this.finalGroupByMonth.push({
            month: this.groupClientBillingList[i].month,
            year: this.groupClientBillingList[i].year,
            amount: amount,
          });
        }
      } else {
        var amount = {
          twoWheeler: 0,
          fourWheeler: 0,
          busAuto: 0,
        };
        if (this.groupClientBillingList[i].mode == 'Four Wheeler') {
          amount.fourWheeler = this.groupClientBillingList[i].amount;
        } else if (this.groupClientBillingList[i].mode == 'Two Wheeler') {
          amount.twoWheeler = this.groupClientBillingList[i].amount;
        } else if (this.groupClientBillingList[i].mode == 'Bus/Auto/Other') {
          amount.busAuto = this.groupClientBillingList[i].amount;
        }
        this.finalGroupByMonth.push({
          month: this.groupClientBillingList[i].month,
          year: this.groupClientBillingList[i].year,
          amount: amount,
        });
      }
    }
  }

  onGenerateBill() {
    this.humanResourceService
      .getGenerateBill(this.client, this.assignment)
      .subscribe((res) => {
        this.commonMessageService.swalAlertWithoutIcon('', res.operationName);
        this.showDetailTable = false;
        this.branch = "";
        this.assignment = "";
        this.client = "";
      });
  }

  exportToExcelClick() {
    this.humanResourceService.getClientBillingReportExcel(this.client, this.assignment)
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "ClientBilling.xlsx";
        link.click();
      });
  }

  exportToPDFClick() {
    var docDefinition = {
      pageOrientation: 'landscape',
      content: [
      ],
    };

    docDefinition.content.push({ text: 'P G BHAGWAT LLP, Chartered Accountants', fontSize: 14, bold: true, alignment: 'center' });
    docDefinition.content.push({ text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', alignment: 'center' });
    docDefinition.content.push({ text: 'Diary Conveyance Details', fontSize: 14, bold: true, alignment: 'center', margin: [0, 10, 0, 5] });
    console.log('finalGroupByMonth', this.finalGroupByMonth);
    docDefinition.content.push({
      table: {
        headerRows: 1,
        widths: ['*', '*', '*', '*', '*'],
        body: [
          [{ text: 'Month/Year', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }, { text: 'Two Wheeler Amount', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }, { text: 'Four Wheeler Amount', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
          { text: '	Bus/Auto/Other Amount', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }, { text: 'Pending to be billed Amount', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }],
          ...this.finalGroupByMonth.map(res => [{ text: `${this.getMonthFormat(res.month)}/${res.year}` }, { text: res.amount.twoWheeler }, { text: res.amount.fourWheeler }, { text: res.amount.busAuto }, { text: (res.amount.twoWheeler + res.amount.fourWheeler + res.amount.busAuto) }]),

        ]
      }
    }
    );
    docDefinition.content.push(' ');
    docDefinition.content.push(' ');
    docDefinition.content.push({
      table: {
        headerRows: 1,
        widths: ['*', '*', '*', '*', '*'],
        body: [
          [{ text: 'Month/Year', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }, { text: '	Employee Name', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }, { text: 'Date', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
          { text: 'Mode', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }, { text: 'Pending to be billed Amount', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }],
          ...this.diaryClientBillingList.map(res => [{ text: `${this.getMonthFormat(res.month)}/${res.year}` }, { text: `${res.user.firstName} ${res.user.lastName}` }, { text: moment(res.entryDate).format('DD-MMM-yyyy') }, { text: res.mode }, { text: res.amount }]),
        ]
      }
    }
    );

    docDefinition.content.push(' ');
    if (this.travelSheetClientBillingList != null) {
      docDefinition.content.push({ text: 'Travel Conveyance Details', fontSize: 14, bold: true, alignment: 'center', margin: [0, 10, 0, 5] });
      docDefinition.content.push({
        table: {
          headerRows: 1,
          widths: ['*', '*', '*'],
          body: [
            [{ text: '	Employee Name', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }, { text: 'Date', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Pending to be billed Amount', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }],
            ...this.travelSheetClientBillingList.map(res => [{ text: `${res.user.firstName} ${res.user.lastName}` }, { text: moment(res.entryDate).format('DD-MMM-yyyy') }, { text: res.amount }]),
          ]
        }
      }
      );
    }
    pdfMake.createPdf(docDefinition).download('ClientBilling.pdf');
  }
}
